// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import cn from 'classnames';
import styles from './survey.module.less';

interface i_progress_props {
    max: number;
    current: number;
}
export const Survey_progress = (props:i_progress_props)=>{
    const {max, current} = props;
    const cls = cn(styles.survey_progress);
    const style = {gridTemplateColumns: `repeat(${max}, 1fr)`};
    return <div className={cls} style={style}>
      {new Array(max).fill(0).map((_v, index)=>{
          return <span key={index}
            className={cn({[styles.inactive]: index > current})}/>;
      })}
    </div>;
};
